import commonUtil from '../../../../../utils/commonUtil';

export const OPENINGGIFTDETAILS_LOAD = 'OPENINGGIFTDETAILS_LOAD';
export const OPENINGGIFTDETAILS_LOAD_SUCCESS = 'OPENINGGIFTDETAILS_LOAD_SUCCESS';
export const OPENINGGIFTDETAILS_LOAD_FAIL = 'OPENINGGIFTDETAILS_LOAD_FAIL';

// export const CLOSINGGIFTDETAILS_LOAD = 'CLOSINGGIFTDETAILS_LOAD';
// export const CLOSINGGIFTDETAILS_LOAD_SUCCESS = 'CLOSINGGIFTDETAILS_LOAD_SUCCESS';
// export const CLOSINGGIFTDETAILS_LOAD_FAIL = 'CLOSINGGIFTDETAILS_LOAD_FAIL';

export const SETOPENINGGIFTFOREVENT_LOAD = 'SETOPENINGGIFTFOREVENT_LOAD';
export const SETOPENINGGIFTFOREVENT_LOAD_SUCCESS = 'SETOPENINGGIFTFOREVENT_LOAD_SUCCESS';
export const SETOPENINGGIFTFOREVENT_LOAD_FAIL = 'SETOPENINGGIFTFOREVENT_LOAD_FAIL';

// const CLOSING = 'closing';
const OPENING = 'opening';
const GETOPENINGORCLOSINGGIFTURL = '/api/EditEvent/getOpeningOrClosingGiftForEvent';
const SETOPENINGORCLOSINGGIFTURL = '/api/EditEvent/setOpeningOrClosingGiftForEvent';


// for get Opening Or Closing Gift Details For Event
export function handleGetGiftOpeningDetails(eventId) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  payload.type = OPENING;
  return {
    types: [OPENINGGIFTDETAILS_LOAD, OPENINGGIFTDETAILS_LOAD_SUCCESS, OPENINGGIFTDETAILS_LOAD_FAIL],
    promise: client => client.post(GETOPENINGORCLOSINGGIFTURL, { data: (payload) }),
  };
}

// for get Closing Gift Details For Event
// export function handleGetGiftClosingDetails(eventId) {
//   const payload = {};
//   payload.brand = commonUtil.getBrand();
//   payload.channel = commonUtil.getChannel();
//   payload.eventId = eventId;
//   payload.type = CLOSING;
//   return {
//     types: [CLOSINGGIFTDETAILS_LOAD, CLOSINGGIFTDETAILS_LOAD_SUCCESS, CLOSINGGIFTDETAILS_LOAD_FAIL],
//     promise: client => client.post(GETOPENINGORCLOSINGGIFTURL, { data: (payload) }),
//   };
// }

// for set Opening Gift For Event
export function handleSetOpeningGiftForEventDetails(eventId, storeSelected, addressId) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  payload.addressId = addressId;
  payload.storeSelected = storeSelected;
  // payload.type = OPENING;
  return commonUtil.triggerServerRequest({ url: SETOPENINGORCLOSINGGIFTURL, method: 'POST', data: payload });
}
